module.exports = __webpack_public_path__ + "assets/images/project/menu/thailand-thumb.jpg?v=2d424851";